import { screenMdMax } from '@utils/match-media';

const SLICK_OPTIONS = {
    arrows: false,
    dots: true,
    rows: 0
};

export default class Shop50Promo {
    constructor($el) {
        this.$el = $el;
        this.$carousel = this.$el.find('[data-region="carousel"]');
        
        this.isSlicked = false;
    }

    init() {
        this.setupCarousel();
        this.setupListeners();
    }

    setupCarousel() {
        if(screenMdMax.matches) {
            this.$carousel.slick(SLICK_OPTIONS);
            this.isSlicked = true;
        } else if(this.isSlicked) {
            this.$carousel.slick('unslick');
            this.isSlicked = false;
        }
    }

    setupListeners() {
        screenMdMax.addEventListener('change', () => this.setupCarousel());
    }
}

$(() => {
    const rootEls = document.querySelectorAll('.js-shop-50-50');
    rootEls?.forEach((el) => {
        const $el = $(el);
        const shopPromo = new Shop50Promo($el);
        shopPromo.init();
    });
});
